// 支付相关
import merge from "lodash/merge"
import axios from "@/interceptor"
import { User } from "./user"

class UserOrderRecord {
  constructor() {
    this.uuid = ""
    this.trade_no = ""
    this.name = ""
    this.wechat_prepay_id = ""
    this.buyer_id = ""
    this.buyer = new User()
    this.signup_id = 0
    this.paid_prize = 0.0
    this.status = "" // unpay, paid, failed
    this.wechatpay_info = undefined // 调用createOrder接口返回时有
    this.sign_info = undefined // 调用接口返回时有
    this.update_time = null
    this.finish_paid_time = null
  }

  get chinese_status() {
    if (this.status == "unpay") {
      return "未支付"
    } else if (this.status == "paid") {
      return "已支付"
    } else if (this.status == "failed") {
      return "支付失败"
    } else {
      return ""
    }
  }
  
  static async getPrizeBySignupId(signup_id) {
    const url = process.env.VUE_APP_API_URL + `api/v1/order/${signup_id}/prize`
    const res = await axios.get(url)
    const prize = res.data.prize
    return prize
  }

  static async fetch(filters) {
    const url = process.env.VUE_APP_API_URL + "api/v1/order/record"
    if (!filters.per_page) {
      filters.per_page = 10
    }
    if (!filters.page) {
      filters.page = 1
    }

    return axios.get(url, { params: filters }).then((res) => {
      let result = {}
      result.results = Array()
      res.data.results.forEach((x) => {
        let c = new UserOrderRecord()
        Object.assign(c, x)
        result.results.push(c)
      })
      result.total = res.data.total
      return result
    })
  }

  static async getRecordBySignupId(signup_id) {
    const res = await UserOrderRecord.fetch({ signup_id: signup_id })
    if (res.results.length <= 0) {
      return null
    } else {
      return res.results[0]
    }
  }

  static async createOrder(params) {
    const data = {
      signup_id: params.signup_id,
      wechat_code: params.wechat_code,
      trade_type: params.trade_type,
    }
    const url = process.env.VUE_APP_API_URL + "api/v1/order/record"
    const res = await axios.post(url, data)
    const pay_info = res.data
    return pay_info
  }

  static async finisheOrder(params) {
    // params支持传入trade_no或者wechat_prepay_id
    // 支付完成后调用
    const data = {
      trade_no: params.trade_no,
      wechat_prepay_id: params.wechat_prepay_id,
    }
    const url = process.env.VUE_APP_API_URL + "api/v1/order/record/finish"
    const res = await axios.post(url, data)
    const pay_info = res.data
    return Object.assign(new UserOrderRecord(), pay_info)
  }

  static async createRefund(params) {
    // 发起退款申请
    const data = {
      trade_no: params.trade_no,
      refund_reason: params.refund_reason,
    }
    const url = process.env.VUE_APP_API_URL + "api/v1/order/refund/create"
    const res = await axios.post(url, data)
    const pay_info = res.data.data
    return Object.assign(new UserOrderRecord(), pay_info)
  }

  static checkIsWechat() {
    // 检测是否在微信的环境下，才好下一步调起支付
    // 只有在微信且版本大于5.0才能支付
    const ua = window.navigator.userAgent
    // alert(ua)
    // const ua = "Mozilla/5.0(iphone;CPU iphone OS 5_1_1 like Mac OS X) AppleWebKit/534.46(KHTML,like Geocko) Mobile/9B206 MicroMessenger/5.0.fds/CPU iphone OS 5_1_1 like Mac OS X) AppleWebKit"
    if (ua.indexOf("MicroMessenger") > -1) {
      const wechatInfo = ua.match(/MicroMessenger\/([\d\.])/i)
      const version = wechatInfo[1]
      if (version >= 5.0) {
        return true
      } else {
        return false
      }
    } else {
      return false
    }
  }
}

export { UserOrderRecord }
